import PropTypes from 'prop-types';

export const PromotionBlockDefaultProps = {
  formats: {},
};

export const PromotionBlockPropTypes = {
  formats: PropTypes.shape({
    desktop: PropTypes.string,
    full: PropTypes.string,
    large: PropTypes.string,
    phone: PropTypes.string,
    tablet: PropTypes.string,
  }),
};
